import type { ReferralCodeSubmissionSource } from "@jti/rest-api";
import { ReferralApi } from "@jti/rest-api";

import { TAGS as MAGENTO_TAGS } from "../../magentoApiSlice/common/tags";
import { magentoApiSlice } from "../../magentoApiSlice/magentoApiSlice";
import { TAGS } from "../common/tags";
import { convertApiError } from "../convertApiError";
import type { LoyaltyApiBuilder } from "../loyaltyApi.types";

export type UpdateLoyaltyReferralCodeEndpointArgs = {
  referralCode: string;
  uuid: string;
  source?: ReferralCodeSubmissionSource;
};

export const updateLoyaltyReferralCodeEndpoint = (builder: LoyaltyApiBuilder) => ({
  updateLoyaltyReferralCode: builder.mutation<boolean, UpdateLoyaltyReferralCodeEndpointArgs>({
    queryFn: async ({ referralCode, uuid, source }) => {
      try {
        const referralApi = ReferralApi.init();
        const result = await referralApi.updateReferralCode(uuid, referralCode, "", source);
        return { data: result };
      } catch (error: unknown) {
        return convertApiError(error);
      }
    },
    invalidatesTags: [TAGS.LOYALTY_REFERRAL],
    onQueryStarted: async (_args, { dispatch, queryFulfilled }) => {
      await queryFulfilled;
      dispatch(magentoApiSlice.util.invalidateTags([MAGENTO_TAGS.CART_ORDER_PRICES]));
    },
  }),
});
